import React from 'react'
import styled from 'styled-components'

const StyledStepFrom = styled.div`
	padding: 2rem 1rem 1rem;
`

export default StyledStepFrom